export const VideoFrequencyStatus = Object.freeze({
  STARTED: 'I',
  PAUSED: 'P',
  FINISHED: 'F',
  WATCHED: '1',
})

export const ShowVideoLecture = Object.freeze({
  NULL: 'N',
  LIBRARY: 'B',
  SCHEDULE: 'P',
  BOTH: 'A',
})
